/** Supabase redirects to an HTTP path; the CRM uses hash routing. */
export function oauthConsentHashRoute(url: URL): string | null {
  if (url.pathname !== "/oauth/consent" && url.pathname !== "/oauth/consent/")
    return null;
  const authorizationId = url.searchParams.get("authorization_id");
  const query = new URLSearchParams();
  if (authorizationId && /^[A-Za-z0-9_-]{1,128}$/.test(authorizationId))
    query.set("authorization_id", authorizationId);
  // No return URL, token, unrelated query parameter or existing fragment is
  // copied. Missing/invalid IDs reach the consent page's explicit error state.
  return `/#/oauth/consent${query.size ? `?${query}` : ""}`;
}

export function oauthConsentLoginState(authorizationId: string) {
  return {
    nextPathname: "/oauth/consent",
    nextSearch: `?${new URLSearchParams({ authorization_id: authorizationId })}`,
  };
}
